export function BrandMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <rect x="2.5" y="2.5" width="23" height="23" rx="4" stroke="currentColor" strokeWidth="1.2" />
      <path d="M7 9.5h4.5V7M7 18.5h4.5V21M21 9.5h-4.5V7M21 18.5h-4.5V21" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="14" cy="14" r="3.2" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="14" cy="14" r="1" fill="currentColor" />
    </svg>
  )
}
